"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var date_fns_1 = require("date-fns");

var React = __importStar(require("react"));

var w3c_keys_1 = require("w3c-keys");

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var InputTextfield_1 = require("../InputTextfield");

var _DateWidget_1 = require("./_DateWidget");

var Stateful_1 = require("./Stateful");

var InputDatepicker =
/** @class */
function (_super) {
  __extends(InputDatepicker, _super);

  function InputDatepicker(props) {
    var _this = _super.call(this, props) || this;

    _this.textInputRef = React.createRef();
    _this.allowBlur = true;

    _this.onWindowBlur = function (e) {
      _this.setState({
        widgetOpen: false
      });

      _this.props.onBlur(_this.props.name, e);
    };

    _this.onSelect = function (value) {
      _this.props.onChange(value, _this.props.name);
    };

    _this.onChange = function (value) {
      _this.setState({
        widgetOpen: true
      });

      _this.props.onChange(value, _this.props.name);
    };

    _this.onWidgetClick = function (e) {
      e.preventDefault();

      if (_this.blurTimeoutID) {
        clearTimeout(_this.blurTimeoutID);
      }

      _this.allowBlur = false;

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          return _this.allowBlur = true;
        });
      } else {
        setTimeout(function () {
          return _this.allowBlur = true;
        }, 100);
      }

      _this.textInputRef.current.focus();
    };

    _this.onInputFocus = function (_name, e) {
      if (e.nativeEvent.relatedTarget !== _this.widgetElm) {
        _this.props.onFocus(_this.props.name, e);
      }

      if (!_this.props.readOnly) {
        _this.setState({
          widgetOpen: true
        });
      }
    };

    _this.onInputBlur = function (_name, e) {
      if (e.nativeEvent.relatedTarget !== _this.widgetElm) {
        _this.setState({
          widgetOpen: false
        });

        _this.props.onBlur(_this.props.name, e);
      }
    };

    _this.onWidgetBlur = function (e) {
      if (e.nativeEvent.relatedTarget !== _this.textInputRef.current) {
        _this.setState({
          widgetOpen: false
        });

        _this.props.onBlur(_this.props.name, e);
      }
    };

    _this.onKeyDown = function (key, _name, e) {
      switch (key) {
        case w3c_keys_1.Key.Escape:
          _this.setState({
            widgetOpen: false
          });

          break;

        case w3c_keys_1.Key.Enter:
          if (_this.state.widgetOpen) {
            e.preventDefault();
          }

          _this.setState({
            widgetOpen: false
          });

          break;

        default:
          if (_this.state.widgetOpen === false) {
            _this.setState({
              widgetOpen: true
            });
          }

          break;
      }
    };

    _this.onClick = function () {
      return _this.state.widgetOpen === false && !_this.props.disabled && !_this.props.readOnly && _this.setState({
        widgetOpen: true
      });
    };

    _this.onIconClick = function () {
      return !_this.props.disabled && _this.setState(function () {
        return {
          widgetOpen: true
        };
      });
    };

    _this.state = {
      widgetOpen: false
    };
    _this.textInputRef = React.createRef();
    return _this;
  }

  InputDatepicker.prototype.componentWillUpdate = function () {
    window.removeEventListener("blur", this.onWindowBlur);
  };

  InputDatepicker.prototype.componentDidUpdate = function (_, prevState) {
    if (prevState.widgetOpen === false && this.state.widgetOpen === true) {
      window.addEventListener("blur", this.onWindowBlur);
    } else if (prevState.widgetOpen === true && this.state.widgetOpen === false) {
      window.removeEventListener("blur", this.onWindowBlur);
    }
  };

  InputDatepicker.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        value = _a.value,
        minDate = _a.minDate,
        maxDate = _a.maxDate,
        placeholder = _a.placeholder;
    var widgetOpen = this.state.widgetOpen;
    var iconName = !this.props.readOnly && !this.props.disabled ? Icon_1.Icon.Names.object___calender : undefined;
    var iconText = !this.props.readOnly && !this.props.disabled ? utils_1.Localization.texts.lsg.component.InputDatepicker.openCalendar : undefined;
    return React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputdatepicker-wrapper"
    }, React.createElement(InputTextfield_1.InputTextfield, __assign({
      className: CSSPrefix_1.lsgPre + "inputdatepicker"
    }, this.props, {
      iconName: iconName,
      iconText: iconText,
      value: value,
      onChange: this.onChange,
      inputRef: this.textInputRef,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      onKeyDown: this.onKeyDown,
      onClick: this.onClick,
      onIconClick: this.onIconClick,
      placeholder: placeholder,
      minDate: minDate,
      maxDate: maxDate,
      type: InputTextfield_1.InputTextfield.Type.date
    })), widgetOpen && React.createElement(_DateWidget_1.DateWidget, {
      onChange: this.onSelect,
      value: date_fns_1.isDate(value) && date_fns_1.isValid(value) && date_fns_1.startOfDay(value),
      onWidgetClick: this.onWidgetClick,
      minDate: minDate ? date_fns_1.startOfDay(minDate) : undefined,
      maxDate: maxDate ? date_fns_1.endOfDay(maxDate) : undefined,
      refCallback: function refCallback(elm) {
        return _this.widgetElm = elm;
      },
      onBlur: this.onWidgetBlur
    }));
  };

  InputDatepicker.Stateful = Stateful_1.Stateful;
  InputDatepicker.defaultProps = {
    label: "",
    value: "",
    placeholder: utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.InputDatepicker.placeholder,
    onChange: function onChange() {
      /* empty */
    },
    onBlur: function onBlur() {
      /* empty */
    },
    onFocus: function onFocus() {
      /* empty */
    }
  };
  return InputDatepicker;
}(React.Component);

exports.InputDatepicker = InputDatepicker;